/** 일~구 (한자어 수) */
const NUM = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
/** 일의 자리~천의 자리 단위 */
const POS_UNIT = ['', '십', '백', '천'];
/** 만 단위 끊기 (만·억·조·경 … — MAX_SAFE_INTEGER까지 충분) */
const MAN_UNITS = ['', '만', '억', '조', '경', '해', '자', '양'];

/**
 * 1~9999를 한자어 수로 읽습니다. (만 단위 안쪽 덩어리)
 */
function readChunkBelowMan(n: number): string {
  if (n <= 0 || n > 9999) return '';
  let out = '';
  let x = n;
  for (let pos = 0; pos < 4; pos++) {
    const d = x % 10;
    x = Math.floor(x / 10);
    if (d === 0) continue;
    const u = POS_UNIT[pos];
    const digitName = d === 1 && pos > 0 ? '' : NUM[d];
    out = digitName + u + out;
  }
  return out;
}

/**
 * 집행 모달 등: 숫자 문자열(0~안전한 정수)을 한글 금액 읽기 문자열로 변환합니다. 끝에 "원"을 붙입니다.
 * 빈 문자열이면 null.
 */
export function budgetAmountDigitsToHangulWon(digits: string): string | null {
  const t = (digits ?? '').trim();
  if (t === '') return null;
  const n = Number(t);
  if (!Number.isFinite(n) || n < 0) return null;
  const v = Math.min(Number.MAX_SAFE_INTEGER, Math.floor(n));
  if (v === 0) return '영원';

  const chunks: number[] = [];
  let rest = v;
  while (rest > 0) {
    chunks.push(rest % 10000);
    rest = Math.floor(rest / 10000);
  }

  let s = '';
  for (let i = chunks.length - 1; i >= 0; i--) {
    const c = chunks[i];
    if (c === 0) continue;
    let piece = readChunkBelowMan(c);
    if (i === 1 && piece === '일') piece = '';
    s += piece + MAN_UNITS[i];
  }
  return `${s}원`;
}
